/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerEject = createReactComponent("outline", "player-eject", "IconPlayerEject", [["path", { "d": "M5 12h14l-7 -8z", "key": "svg-0" }], ["path", { "d": "M5 16m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-1" }]]);

export { IconPlayerEject as default };
//# sourceMappingURL=IconPlayerEject.mjs.map
